/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Explorer_Info_Due_Date_Failed_ToastInputs */

const en_explorer_info_due_date_failed_toast = /** @type {(inputs: Explorer_Info_Due_Date_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to update due date: ${i?.error}`)
};

const fr_explorer_info_due_date_failed_toast = /** @type {(inputs: Explorer_Info_Due_Date_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to update due date: ${i?.error}`)
};

const de_explorer_info_due_date_failed_toast = /** @type {(inputs: Explorer_Info_Due_Date_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to update due date: ${i?.error}`)
};

const it_explorer_info_due_date_failed_toast = /** @type {(inputs: Explorer_Info_Due_Date_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to update due date: ${i?.error}`)
};

const ru_explorer_info_due_date_failed_toast = /** @type {(inputs: Explorer_Info_Due_Date_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to update due date: ${i?.error}`)
};

const es_explorer_info_due_date_failed_toast = /** @type {(inputs: Explorer_Info_Due_Date_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to update due date: ${i?.error}`)
};

const zh_cn2_explorer_info_due_date_failed_toast = /** @type {(inputs: Explorer_Info_Due_Date_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to update due date: ${i?.error}`)
};

const ja_explorer_info_due_date_failed_toast = /** @type {(inputs: Explorer_Info_Due_Date_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to update due date: ${i?.error}`)
};

const hi_explorer_info_due_date_failed_toast = /** @type {(inputs: Explorer_Info_Due_Date_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to update due date: ${i?.error}`)
};

const pt_pt2_explorer_info_due_date_failed_toast = /** @type {(inputs: Explorer_Info_Due_Date_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to update due date: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to update due date: {error}" |
*
* @param {Explorer_Info_Due_Date_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_due_date_failed_toast = /** @type {((inputs: Explorer_Info_Due_Date_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Due_Date_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_due_date_failed_toast(inputs)
	if (locale === "de") return de_explorer_info_due_date_failed_toast(inputs)
	if (locale === "it") return it_explorer_info_due_date_failed_toast(inputs)
	if (locale === "ru") return ru_explorer_info_due_date_failed_toast(inputs)
	if (locale === "es") return es_explorer_info_due_date_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_due_date_failed_toast(inputs)
	if (locale === "ja") return ja_explorer_info_due_date_failed_toast(inputs)
	if (locale === "hi") return hi_explorer_info_due_date_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_due_date_failed_toast(inputs)
	return en_explorer_info_due_date_failed_toast(inputs)
});